import { onMounted } from 'vue';

/**
 * Keyboard accessibility for nav links and sub-nav links
 */
export default function useKeyboardSubNav() {

  /**
   * Setup all the event listeners for specific keys
   * based on the given set of elements.
   *
   * @param Array parentLinks
   * @param Array subMenus
   */
  const enableKeyboardNavigation = (parentLinks, subMenus) => {
    if (!parentLinks) {
      return;
    }

    parentLinks.forEach((link, index) => {
      link.addEventListener('keydown', (event) => {
        const { keyCode } = event;

        if (keyCode === 38) { // Arrow Up key
          event.preventDefault();
          const previousIndex = index > 0 ? index - 1 : parentLinks.length - 1;
          parentLinks[previousIndex].focus();
        } else if (keyCode === 40) { // Arrow Down key
          event.preventDefault();
          const nextIndex = index < parentLinks.length - 1 ? index + 1 : 0;
          parentLinks[nextIndex].focus();
        } else if (keyCode === 36) { // Home key
          event.preventDefault();
          parentLinks[0].focus();
        } else if (keyCode === 35) { // End key
          event.preventDefault();
          parentLinks[parentLinks.length - 1].focus();
        } else if (keyCode === 32) { // Space key
          link.click();
        }
      });
    });

    if (!subMenus) {
      return;
    }

    subMenus.forEach((subMenu) => {
      if (subMenu === null) {
        return;
      }
      const childLinks = subMenu.querySelectorAll('a');

      childLinks.forEach((link, index) => {
        link.addEventListener('keydown', (event) => {
          const { keyCode } = event;

          if (keyCode === 38) { // Arrow Up key
            event.preventDefault();
            if (index > 0) {
              childLinks[index - 1].focus();
            } else {
              childLinks[childLinks.length - 1].focus();
            }
          } else if (keyCode === 40) { // Arrow Down key
            event.preventDefault();
            if (index < childLinks.length - 1) {
              childLinks[index + 1].focus();
            } else {
              childLinks[0].focus();
            }
          } else if (keyCode === 36) { // Home key
            event.preventDefault();
            childLinks[0].focus();
          } else if (keyCode === 35) { // End key
            event.preventDefault();
            childLinks[childLinks.length - 1].focus();
          }
        });
      });
    });
  };

  /**
   * Takes a subMenu and iterates through
   * its child links setting its focus state.
   *
   * When 'isActive' is set to true, each link
   * is enabled and focus functionality is restored
   * and when set to false, each link is disabled.
   *
   * @param Element subMenu
   * @param Boolean isActivate
   */
  const toggleLinksFocus = (subMenu, isActivate) => {
    if (!subMenu) {
      return;
    }

    // Get the list of links for this sub menu
    const childLinks = subMenu.querySelectorAll('a');

    // For each link remove the aria-hidden and tabindex attributes
    childLinks.forEach((link) => {

      // When set to true, restore native focus functionality of links
      if (isActivate) {
        link.removeAttribute('tabindex');
        link.removeAttribute('aria-hidden');

        return;
      }

      // Otherwise, disable focus functionality of links
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
    });
  }

  onMounted(enableKeyboardNavigation);

  return {
    enableKeyboardNavigation,
    toggleLinksFocus,
  };
}
